import { updateBookingStatus } from './bookingData';
import { updateBookingJourneyStage } from './journey';

/** Run a list-safe next action (see QUICK_ACTIONS). Returns { data } or { error }. */
export async function runQuickAction(row, act) {
  switch (act?.kind) {
    case 'status':
      return updateBookingStatus(row.id, act.target);
    case 'journey':
      return updateBookingJourneyStage(row.id, act.target);
    default:
      return { error: { message: 'Open the job to do this step.' } };
  }
}
